import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ApplicationMenuService {
    private ngt18Url: string = environment.API_URL+'main/';

    constructor(private http:HttpClient){
    }

    getTopNavList(data) {
        return this.http.post(this.ngt18Url + 'core.instance.topNavigation', data);
    }

    insertSession(data) {
        return this.http.post(this.ngt18Url+"core.instance.setSession",data);
    }
    addShortCuts(data) {
        return this.http.post(this.ngt18Url + 'module.das.shortcutCreate', data);
    }
    getShortCuts(data) {
        return this.http.post(this.ngt18Url + 'module.das.shortcutList', data);
    }
    deleteShortCuts(data) {
        return this.http.post(this.ngt18Url + 'module.das.shortcutDelete', data);
    }
    renameShortcut(data) {
        return this.http.post(this.ngt18Url + 'module.das.shortcutRename', data);
    }
}